<div *ngIf="carousel" class="carousel-wrapper">
  <div class="keen-navigation-wrapper">
    <div class="arrow arrow-left" (click)="doPrev()">
      <img src="/assets/icons/carousel-arrow-right.svg" alt="" />
    </div>
    <div class="keen-slider" #sliderRef>
      <div
        *ngFor="let slide of carousel; index as slideIndex"
        class="keen-slider__slide"
      >
        <div
          class="carousel-slide"
          [class.active-slide]="slideIndex === currentSlideIndex"
        >
          <ng-container
            [ngTemplateOutlet]="templateRef"
            [ngTemplateOutletContext]="{ $implicit: slide }"
          ></ng-container>
        </div>
      </div>
    </div>
    <div class="arrow arrow-right" (click)="doNext()">
      <img src="/assets/icons/carousel-arrow-right.svg" alt="" />
    </div>
  </div>
</div>
